import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteContentItemFromOrderedContentSection
} from 'zoomforth_codesbane_editor/action_creators/sections.ordered_content.js';

import {
  getDisplayableContentDescriptor
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

const mapStateToProps = (state, { section, contentItem }) => {
  return {
    title: 'Really delete slide?',
    body: `You are about to delete this ${getDisplayableContentDescriptor(section, contentItem)}. This cannot be undone.`,
    confirmText: 'Delete Slide',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { contentItem }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteContentItemFromOrderedContentSection(contentItem));
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteSlideshowItemModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeleteSlideshowItemModal.editorModalName = 'ConfirmDeleteSlideshowItemModal';

export default ConfirmDeleteSlideshowItemModal;
